// extracted by mini-css-extract-plugin
export var orders = "styles_orders__rOQre";